import { getConceptCodes } from "@intocare/datatypes/lib/code-system";
import { composeValueSet } from "@intocare/datatypes/lib/value-set";

import { OBSERVATION_CONTEXT } from "../../code-system/observation-context";

export const OBSERVATION_CONTEXT_DISPLAY = composeValueSet({
	name: "OBSERVATION_CONTEXT_DISPLAY",
	description: "Current selection of contexts for displaying observations.",
	system: OBSERVATION_CONTEXT,
	include: getConceptCodes(OBSERVATION_CONTEXT),
});
